<template>
  <div>
    <div class="toolbar">
      <ListSearchForm @change="fetchData" ref="search" style="display:inline-block;"></ListSearchForm>
      <el-button type="primary" @click="handleBatch">添加题型</el-button>
    </div>
    <el-table
      ref="multipleTable"
      :data="tableData"
      border
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="60"></el-table-column>
      <el-table-column prop="id" label="编号" sortable></el-table-column>
      <el-table-column prop="level" label="等级"></el-table-column>
      <el-table-column prop="name" label="内部标题" show-overflow-tooltip></el-table-column>
      <el-table-column prop="title" label="展示标题" show-overflow-tooltip></el-table-column>
      <el-table-column prop="template" label="模板"></el-table-column>
      <el-table-column prop="status" label="状态"></el-table-column>
      <el-table-column fixed="right" label="操作" width="120">
        <template slot-scope="scope">
          <el-button @click="updateType(scope.row)" type="text" size="small">编辑</el-button>
          <el-button @click="copyType(scope.row)" type="text" size="small">复制</el-button>
          <el-button @click="handleDelete(scope.row)" type="text" size="small">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 50, 100, 200]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      v-if="total>pageSize"
    >
    </el-pagination>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="60%">
      <TypeForm ref="form"></TypeForm>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitType">确 定</el-button>
      </div>
    </el-dialog>
    <Sidebar :visible.sync="batchVisible" header="批量添加">
      <TypeForm ref="batchform"></TypeForm>
      <div class="text-right">
        <el-button @click="batchVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitBatch">确 定</el-button>
      </div>
    </Sidebar>
  </div>
</template>

<script>
import TypeForm from './TypeForm'
import Sidebar from './../Sidebar'
import ListSearchForm from './TypeSearch'

export default {
  data () {
    return {
      keyword: '',
      total: 0,
      currentPage: 1,
      pageSize: 10,
      tableData: [],
      multipleSelection: [],
      dialogTitle: '添加题型',
      dialogVisible: false,
      batchVisible: false
    }
  },
  components: { TypeForm, Sidebar, ListSearchForm },
  mounted () {
    this.fetchData()
  },
  methods: {
    toggleSelection (rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    fetchData () {
      this.$http.get(this.$urls.exercise_type_list, {
        params: {
          keywords: this.keyword,
          page: this.currentPage,
          'per-page': this.pageSize,
          "filter[and][0][level]": this.$refs.search.level,
          "filter[and][1][or][0][name][like]": this.$refs.search.search,
          "filter[and][1][or][1][title][like]": this.$refs.search.search,
          "filter[and][1][or][2][template][like]": this.$refs.search.search
        }
      }).then(res => {
        this.total = Number.parseInt(res.headers['x-pagination-total-count'])
        this.currentPage = Number.parseInt(res.headers['x-pagination-current-page'])
        this.tableData = res.data
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.fetchData()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.fetchData()
    },
    createType () {
      this.dialogVisible = true
      this.dialogTitle = '添加题型'
      setTimeout(() => {
        if (this.$refs.form.id) {
          this.$refs.form.reset()
        }
      }, 1)
    },
    submitType () {
      this.$refs.form.submit().then(res => {
        this.dialogVisible = false
        this.fetchData()
        this.$refs.form.reset()
      })
    },
    updateType (item) {
      this.dialogVisible = true
      this.dialogTitle = '编辑题型'
      setTimeout(() => {
        this.$refs.form.reset(item)
      }, 10)
    },
    copyType (item) {
      this.dialogVisible = true
      this.dialogTitle = '复制题型'
      setTimeout(() => {
        this.$refs.form.reset(Object.assign({}, item, {id: 0}))
      }, 10)
    },
    handleDelete (item) {
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(res => {
        this.$http.put(this.$urls.exercise_type_update, { status: 0 }, {
          params: {id: item.id}
        }).then(() => {
          this.fetchData()
        })
      })
    },
    handleBatch () {
      this.batchVisible = true;
    },
    submitBatch () {
      this.$refs.batchform.submit().then(() => {
        this.fetchData()
        let {level, template} = this.$refs.batchform
        this.$refs.batchform.reset({level, template})
      })
    }
  }
}
</script>